import { Component, OnInit } from '@angular/core';
import { OrganisationsService } from '../../../services';
import { IOrganisationTelephonyInfo } from '../../../interfaces/telephony/organisation-telephony-info';
import { TelephonyService } from '../../../services';
import { IOrganisationPhoneNumber } from '../../../interfaces/telephony/organisation-phone-number';
import { ConfirmationService } from 'primeng/api';
import { _deepClone } from 'fast-json-patch/module/helpers';

@Component({
  selector: 'app-telephone-number-admin',
  styleUrls: ['./telephone-number-admin.component.scss'],
  templateUrl: './telephone-number-admin.component.html',
})
export class TelephoneNumberAdminComponent implements OnInit {
  constructor(
    private organisationService: OrganisationsService,
    private telephonyService: TelephonyService,
    private confirmationService: ConfirmationService,
  ) {
    this.deleteNumber = this.deleteNumber.bind(this);
    this.cellEdit = this.cellEdit.bind(this);
  }

  selectedOrganisationData: IOrganisationTelephonyInfo;
  selectedNumber: any;
  selectedOrganisationId: any;

  loading = false;
  showAddDialog = false;
  newPhoneNumber: string;

  delistedNumbers: IOrganisationPhoneNumber[];
  filteredDelistedNumbers: IOrganisationPhoneNumber[];

  searchText: any;
  searchPhoneText: any;

  // used when searching for a particular number
  phoneNumbers: IOrganisationPhoneNumber[];
  filteredPhoneNumbers: IOrganisationPhoneNumber[];
  excludeDelisted = false;

  warnings = [];
  loadingWarnings: boolean;
  activeIndex: number;

  ngOnInit() {
    this.loadDelistedNumbers();
    this.loadWarnings();
  }

  onOrganisationChange(event: any) {
    console.log('Organisation selected: ', event);

    this.selectedOrganisationId = event;
    this.loadOrganisation();
  }

  loadDelistedNumbers() {
    this.telephonyService.getDelistedNumbers().then((result) => {
      this.delistedNumbers = result;
      this.filteredDelistedNumbers = _deepClone(this.delistedNumbers);
    });
  }

  loadWarnings() {
    this.loadingWarnings = true;

    this.warnings = [];
    this.telephonyService
      .getWarnings()
      .then((result) => {
        console.log('Warnings: ', result);

        this.warnings = result.map((warning) => ({
          severity: 'warn',
          summary: 'Warning',
          detail: warning,
        }));

        this.loadingWarnings = false;
      })
      .catch(() => {
        this.loadingWarnings = false;
      });
  }

  loadOrganisation() {
    this.loading = true;

    // load telephone numbers for selected organisation
    this.organisationService.getTelephonyInfo(this.selectedOrganisationId).then((result) => {
      this.selectedOrganisationData = result;
      this.loading = false;
    });
  }

  addTelephoneNumber() {
    this.showAddDialog = true;
  }

  deleteNumber(entry: any, isDelisted) {
    //console.log("Delete number: ", entry);
    this.confirmationService.confirm({
      message: `Are you sure you want to 'delete' number '${entry.phoneNumber}'`,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.telephonyService
          .deleteTelephoneNumber(this.selectedOrganisationId, entry.id)
          .then(() => {
            if (isDelisted) {
              this.loadDelistedNumbers();
            } else if (this.selectedOrganisationId) {
              this.loadOrganisation();
            }

            this.loadWarnings();

            if (this.searchPhoneText) {
              this.searchPhoneTextChanged(this.searchPhoneText);
            }
          });
      },
      reject: () => {},
    });
  }

  async cellEdit(item: any) {
    console.log('Number edited: ', item);

    const canProceed = await this.telephonyService.checkExistingNumberAssignment(
      item.phoneNumber,
      item.id,
      item.organisationId,
    );

    if (!canProceed) {
      item.phoneNumber = item.originalNumber;
      return;
    }

    await this.telephonyService.updateOrganisationPhoneNumber(item.id, item.phoneNumber);
    item.originalNumber = item.phoneNumber;

    if (this.activeIndex == 0) {
      this.loadOrganisation();
    } else if (this.activeIndex == 1) {
      this.searchPhoneTextChanged(this.searchPhoneText);
    } else if (this.activeIndex == 2) {
      this.loadDelistedNumbers();
    }
  }

  async addPhoneNumber() {
    const canProceed = await this.telephonyService.checkExistingNumberAssignment(
      this.newPhoneNumber,
      null,
      this.selectedOrganisationId,
    );

    if (!canProceed) {
      return;
    }

    this.showAddDialog = false;

    const dto = {
      organisationId: this.selectedOrganisationId,
      phoneNumber: this.newPhoneNumber,
    } as IOrganisationPhoneNumber;

    await this.telephonyService.setOrganisationPhoneNumber(dto);
    this.loadOrganisation();
  }

  searchTextChanged(text: string) {
    this.filteredDelistedNumbers = _deepClone(
      this.delistedNumbers.filter((x) => x.phoneNumber.indexOf(text) > -1),
    );
  }

  searchPhoneTextChanged(event: any) {
    this.telephonyService.getPhoneNumberData(event).then((res) => {
      this.phoneNumbers = res;
      this.excludeDelistedChange();
    });
  }

  excludeDelistedChange() {
    this.filteredPhoneNumbers = this.excludeDelisted
      ? this.phoneNumbers.filter((x) => x.organisationId)
      : this.phoneNumbers;
  }
}
